import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { useCallback, useMemo } from 'react';
import { DropdownToolContent } from './DropdownToolContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function hasLinkSupportedTypes(field) {
  if (typeof field !== 'object' || field === null) return false;
  if (!('supported_types' in field)) return true;
  return Array.isArray(field.supported_types);
}
const URL_TYPE_I18N_KEYS = {
  EXTERNAL: 'ContentComponents.cmv2.fields.url.linkType.linkLabels.EXTERNAL',
  FILE: 'ContentComponents.cmv2.fields.url.linkType.linkLabels.FILE',
  CONTENT: 'ContentComponents.cmv2.fields.url.linkType.linkLabels.CONTENT',
  BLOG: 'ContentComponents.cmv2.fields.url.linkType.linkLabels.BLOG',
  CALL_TO_ACTION: 'ContentComponents.cmv2.fields.url.linkType.linkLabels.CALL_TO_ACTION',
  PAYMENT: 'ContentComponents.cmv2.fields.url.linkType.linkLabels.PAYMENT',
  EMAIL_ADDRESS: 'ContentComponents.cmv2.fields.url.linkType.linkLabels.EMAIL_ADDRESS',
  PHONE_NUMBER: 'ContentComponents.cmv2.fields.url.linkType.linkLabels.PHONE_NUMBER',
  WHATSAPP_NUMBER: 'ContentComponents.cmv2.fields.url.linkType.linkLabels.WHATSAPP_NUMBER'
};
function getUrlTypeOptions(supportedTypes) {
  if (!supportedTypes) return [];
  return supportedTypes.map(urlType => ({
    value: urlType,
    text: I18n.text(URL_TYPE_I18N_KEYS[urlType])
  }));
}
const DEFAULT_LINK_VALUE = {
  url: {
    type: 'EXTERNAL',
    href: ''
  },
  open_in_new_tab: false,
  no_follow: false
};
export function LinkTool({
  info,
  config,
  onFieldChange
}) {
  const {
    field,
    path,
    currentValue
  } = info;
  const rawValue = currentValue || field.default;
  const linkValue = useMemo(() => Object.assign({}, DEFAULT_LINK_VALUE, rawValue, {
    url: Object.assign({}, DEFAULT_LINK_VALUE.url, rawValue === null || rawValue === void 0 ? void 0 : rawValue.url)
  }), [rawValue]);
  const supportedTypes = hasLinkSupportedTypes(field) ? field.supported_types : undefined;
  const urlTypeOptions = useMemo(() => getUrlTypeOptions(supportedTypes), [supportedTypes]);
  const updateLinkValue = useCallback(updates => {
    onFieldChange(path, Object.assign({}, linkValue, updates));
  }, [linkValue, path, onFieldChange]);
  return /*#__PURE__*/_jsxs(DropdownToolContent, {
    info: info,
    config: config,
    children: [/*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx("strong", {
        children: I18n.text('inpage.fieldSettingsToolbar.link.title')
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text('inpage.fieldSettingsToolbar.link.linkTo'),
      children: /*#__PURE__*/_jsx(Select, {
        value: linkValue.url.type,
        onChange: opt => opt && updateLinkValue({
          url: Object.assign({}, linkValue.url, {
            type: opt.value
          })
        }),
        options: urlTypeOptions,
        anchorType: "button"
      })
    }), linkValue.url.type === 'EXTERNAL' && /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text('ContentComponents.cmv2.fields.url.input.labelsByType.EXTERNAL'),
      children: /*#__PURE__*/_jsx(TextInput, {
        value: linkValue.url.href || '',
        onChange: e => updateLinkValue({
          url: Object.assign({}, linkValue.url, {
            href: e.target.value
          })
        }),
        placeholder: I18n.text('inpage.fieldSettingsToolbar.link.placeholder')
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(Text, {
        children: I18n.text('ContentComponents.cmv2.fields.link.toggles.open_in_new_tab.label')
      }), /*#__PURE__*/_jsx(Toggle, {
        checked: linkValue.open_in_new_tab,
        onChange: e => updateLinkValue({
          open_in_new_tab: e.target.checked
        }),
        size: "extra-small"
      })]
    })]
  });
}